import React from 'react'
import { Breadcrumbs, Link, Typography } from '@material-ui/core'
import { PolicyDispatchingStackParamList, StockOutTabType } from '../PolicyDispatchingStackParamList'

type RouteName = keyof PolicyDispatchingStackParamList

type Props = {
  routeName: RouteName
  routeParams?: unknown
}

const getStockOutPage = (tab?: StockOutTabType) => {
  switch (tab) {
    case 'agentGroup':
      return 'Giao hợp đồng qua Nhóm đại lý'
    case 'postOffice':
      return 'Giao hợp đồng qua Bưu Điện'
    case 'agent':
      return 'Giao hợp đồng qua Đại lý'
    default:
      return 'Stock Out - Đại lý'
  }
}

const getBreadcrumbMeta = (routeName: RouteName, routeParams?: unknown) => {
  switch (routeName) {
    case 'PDStockInScreen':
      return { section: 'Quản lý hợp đồng', page: 'Quản lý nhập kho' }
    case 'PDStockOutScreen': {
      const params = routeParams as PolicyDispatchingStackParamList['PDStockOutScreen']
      return {
        section: 'Quản lý hợp đồng',
        page: getStockOutPage(params?.tab)
      }
    }
    case 'PDAuthorizationLetterScreen':
      return { section: 'Quản lý hợp đồng', page: 'Quản lý Giấy ủy quyền' }
    case 'PDACKScreen':
      return { section: 'Quản lý Thư xác nhận' }
    case 'PDContractInformationScreen':
      return { section: 'Tìm nhanh', page: 'Thông tin hợp đồng' }
    case 'PDOldContractInformationScreen':
      return { section: 'Tìm nhanh', page: 'Thông tin hợp đồng cũ' }
    case 'PDAgentContractScreen':
      return { section: 'Tìm nhanh', page: 'Hợp đồng theo số đại lý' }
    case 'PDAgentInformationScreen':
      return { section: 'Tìm nhanh', page: 'Thông tin đại lý' }
    case 'PDUpdatedLetterScreen':
      return { section: 'Tìm nhanh', page: 'Thư xác nhận đã cập nhật' }
    case 'PDNotReturnLetterScreen':
      return { section: 'Tìm nhanh', page: 'Thư xác nhận chưa hoàn trả' }
    case 'PDAuthorizeLetterScreen':
      return { section: 'Tìm nhanh', page: 'Giấy ủy quyền' }
    case 'PDReportScreen': {
      return {
        section: 'Báo cáo'
      }
    }
    case 'PDCheckLogScreen':
      return { section: 'Tra cứu nhật ký' }
    case 'PDUploadScreen':
      return { section: 'Tải lên' }
    case 'PDRDOManagementScreen':
      return { section: 'Quản lý RDO', page: 'Danh sách RDO' }
    case 'PDCreateRdoScreen': {
      const params = routeParams as PolicyDispatchingStackParamList['PDCreateRdoScreen']
      return { section: 'Quản lý RDO', page: params?.rdoItem ? 'Chỉnh sửa RDO' : 'Tạo RDO mới' }
    }
    default:
      return { section: 'PD Web', page: 'Home' }
  }
}

export default function PolicyDispatchingBreadcrumb({ routeName, routeParams }: Props) {
  const { section, page } = getBreadcrumbMeta(routeName, routeParams)

  return (
    <Breadcrumbs aria-label="breadcrumb" style={{ marginBottom: 8, fontSize: 14, fontWeight: 700 }}>
      <Link href="/user/home" style={{ color: '#6a7282', textDecoration: 'none' }}>
        Trang chủ
      </Link>
      {section && <Typography style={{ color: '#000', fontSize: 14, fontWeight: 600 }}>{section}</Typography>}
      {page && <Typography style={{ color: '#000', fontSize: 14, fontWeight: 600 }}>{page}</Typography>}
    </Breadcrumbs>
  )
}
